"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryBoxProps = void 0;
/* istanbul ignore file @preserve */ const categoryBoxProps = exports.categoryBoxProps = {
    buttonText: 'View',
    imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=856697f4-5936-4c92-8228-a017337d21a8&name=SkincareSunZoneUvProtectorFaceExposedAreasSpf50HighTheOne5in1ColourStylistLipstickGarnetAttraction23&inputFormat=jpg',
    relativeUrl: '/campaigns/editorials/testtheme',
    title: 'Skincare'
};
